var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.transactions
    ? _c(
        "b-overlay",
        { attrs: { show: _vm.loading } },
        [
          _c(
            "b-row",
            [
              _c("b-col", { staticClass: "text-left" }, [
                _c("h2", [_vm._v(_vm._s(_vm.heading))]),
              ]),
            ],
            1
          ),
          _vm.selectedCount > 0
            ? _c(
                "b-row",
                { staticClass: "mb-2" },
                [
                  _c(
                    "b-col",
                    { staticClass: "d-flex align-items-center" },
                    [
                      _c("div", { staticClass: "mr-3" }, [
                        _vm._v(_vm._s(_vm.selectedCount) + " selected"),
                      ]),
                      _c("div", { staticClass: "text-muted small mr-2" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.canAsk
                                ? "Each selected must have a Question (or files)"
                                : "Each selected must have an Answer (or files)"
                            ) +
                            " "
                        ),
                      ]),
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            size: "sm",
                            variant: "success",
                            disabled: !_vm.canBulkSend || _vm.bulkSending,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.sendAll()
                            },
                          },
                        },
                        [
                          _vm.bulkSending
                            ? _c("b-spinner", {
                                staticClass: "mr-1",
                                attrs: { small: "" },
                              })
                            : _vm._e(),
                          _vm._v(" Send All "),
                        ],
                        1
                      ),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            size: "sm",
                            variant: "outline-secondary",
                            disabled: _vm.bulkSending,
                          },
                          on: { click: _vm.clearSelection },
                        },
                        [_vm._v(" Clear ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("b-table", {
            staticClass: "small",
            attrs: {
              id: _vm.tableName,
              fields: _vm.headers,
              items: _vm.transactions,
              "sort-by": _vm.sort.column,
              "sort-desc": _vm.sort.reverse,
              "sort-compare": _vm.sortCompare,
              bordered: "",
              "sticky-header": "600px",
              "show-empty": "",
              "primary-key": "id",
              "tbody-tr-class": "align-middle",
              "tfoot-tr-class": "align-middle",
              striped: "",
            },
            on: {
              "update:sortBy": function ($event) {
                return _vm.$set(_vm.sort, "column", $event)
              },
              "update:sort-by": function ($event) {
                return _vm.$set(_vm.sort, "column", $event)
              },
              "update:sortDesc": function ($event) {
                return _vm.$set(_vm.sort, "reverse", $event)
              },
              "update:sort-desc": function ($event) {
                return _vm.$set(_vm.sort, "reverse", $event)
              },
              "sort-changed": (ctx) => _vm.$emit("sort-changed", ctx),
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "head(_select)",
                  fn: function () {
                    return [
                      _c("b-form-checkbox", {
                        attrs: {
                          indeterminate: _vm.isIndeterminate,
                          checked: _vm.allOnPageSelected,
                          "aria-label": "Select all",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.toggleSelectAll($event)
                          },
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "cell(_select)",
                  fn: function (data) {
                    return [
                      _c("b-form-checkbox", {
                        attrs: {
                          checked: _vm.isSelected(data.item.id),
                          "aria-label": "Select row",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.toggleSelect(data.item.id, $event)
                          },
                        },
                      }),
                    ]
                  },
                },
                {
                  key: "cell(qbtype)",
                  fn: function (data) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(data.item.qbtype.replace(/([A-Z])/g, " $1")) +
                          " "
                      ),
                    ]
                  },
                },
                {
                  key: "cell(amount)",
                  fn: function (data) {
                    return [
                      _c("strong", [
                        _vm._v(_vm._s(_vm._f("currency")(data.item.amount))),
                      ]),
                    ]
                  },
                },
                {
                  key: "cell(statusRank)",
                  fn: function (data) {
                    return [
                      _c("span", [_vm._v(_vm._s(_vm.getStatus(data.item)))]),
                    ]
                  },
                },
                {
                  key: "cell(question)",
                  fn: function (data) {
                    return [
                      _c(
                        "div",
                        [
                          _vm.senderStamp(data.item, "question")
                            ? _c(
                                "div",
                                { staticClass: "text-muted small mb-1" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.senderStamp(data.item, "question")
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.canAsk
                            ? _c("b-form-textarea", {
                                staticClass: "w-100",
                                attrs: {
                                  value: _vm.draftText(data.item, "question"),
                                  rows: "3",
                                  "max-rows": "6",
                                  placeholder: _vm.placeholderFor(data.item),
                                  disabled:
                                    _vm.sendingMap[
                                      _vm.getKey(data.item.id, "question")
                                    ],
                                  state: _vm.fieldState(
                                    data.item.id,
                                    "question"
                                  ),
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.setDraft(
                                      data.item.id,
                                      "question",
                                      $event
                                    )
                                  },
                                },
                              })
                            : _c(
                                "div",
                                {
                                  staticClass: "text-muted",
                                  staticStyle: { "white-space": "pre-wrap" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.draftText(data.item, "question") ||
                                          "—"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                          _vm.docsForSide(data.item, "question").length
                            ? _c("div", { staticClass: "mt-2" }, [
                                _c(
                                  "ul",
                                  { staticClass: "mb-2 pl-3 small" },
                                  _vm._l(
                                    _vm.docsForSide(data.item, "question"),
                                    function (d) {
                                      return _c("li", { key: `qdoc-${d.id}` }, [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "doc-link",
                                            attrs: {
                                              href: d.url,
                                              download: d.documentname,
                                              target: "_blank",
                                              rel: "noopener",
                                            },
                                          },
                                          [_vm._v(_vm._s(d.documentname))]
                                        ),
                                      ])
                                    }
                                  ),
                                  0
                                ),
                              ])
                            : _vm._e(),
                          _c("div", { staticClass: "mt-1" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center justify-content-end",
                              },
                              [
                                _c("input", {
                                  ref: _vm.fileRefId(data.item.id, "question"),
                                  staticClass: "d-none",
                                  attrs: { type: "file", multiple: "" },
                                  on: {
                                    change: function ($event) {
                                      return _vm.onNativeFilesPicked(
                                        data.item.id,
                                        "question",
                                        $event
                                      )
                                    },
                                  },
                                }),
                                _vm.canAsk
                                  ? _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            modifiers: { hover: true },
                                          },
                                        ],
                                        staticClass: "mr-2",
                                        attrs: {
                                          size: "sm",
                                          variant: "outline-secondary",
                                          title: "Add attachments",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.triggerFilePicker(
                                              data.item.id,
                                              "question"
                                            )
                                          },
                                        },
                                      },
                                      [_c("b-icon-paperclip")],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.canAsk
                                  ? _c(
                                      "b-button",
                                      {
                                        staticClass: "mr-2",
                                        attrs: {
                                          size: "sm",
                                          variant: "success",
                                          disabled:
                                            (!_vm.hasDraft(
                                              data.item.id,
                                              "question"
                                            ) &&
                                              !_vm.hasFiles(
                                                data.item.id,
                                                "question"
                                              )) ||
                                            _vm.sendingMap[
                                              _vm.getKey(
                                                data.item.id,
                                                "question"
                                              )
                                            ],
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.send(
                                              data.item,
                                              "question"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm.sendingMap[
                                          _vm.getKey(data.item.id, "question")
                                        ]
                                          ? _c("b-spinner", {
                                              staticClass: "mr-1",
                                              attrs: { small: "" },
                                            })
                                          : _vm._e(),
                                        _vm._v(" Send "),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm.hasFiles(data.item.id, "question")
                              ? _c(
                                  "ul",
                                  {
                                    staticClass:
                                      "mt-2 mb-0 pl-3 small text-muted",
                                  },
                                  _vm._l(
                                    _vm.filesOf(data.item.id, "question"),
                                    function (f, i) {
                                      return _c(
                                        "li",
                                        { key: `qf-${data.item.id}-${i}` },
                                        [_vm._v(" " + _vm._s(f.name) + " ")]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "cell(answer)",
                  fn: function (data) {
                    return [
                      _c(
                        "div",
                        [
                          _vm.senderStamp(data.item, "answer")
                            ? _c(
                                "div",
                                { staticClass: "text-muted small mb-1" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.senderStamp(data.item, "answer")
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.canAnswer
                            ? _c("b-form-textarea", {
                                staticClass: "w-100",
                                attrs: {
                                  value: _vm.draftText(data.item, "answer"),
                                  rows: "3",
                                  "max-rows": "6",
                                  placeholder: "Reply to bookkeeper…",
                                  disabled:
                                    _vm.sendingMap[
                                      _vm.getKey(data.item.id, "answer")
                                    ],
                                  state: _vm.fieldState(data.item.id, "answer"),
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.setDraft(
                                      data.item.id,
                                      "answer",
                                      $event
                                    )
                                  },
                                },
                              })
                            : _c(
                                "div",
                                {
                                  staticClass: "text-muted",
                                  staticStyle: { "white-space": "pre-wrap" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.draftText(data.item, "answer") ||
                                          "—"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                          _vm.docsForSide(data.item, "answer").length
                            ? _c("div", { staticClass: "mt-2" }, [
                                _c(
                                  "ul",
                                  { staticClass: "mb-2 pl-3 small" },
                                  _vm._l(
                                    _vm.docsForSide(data.item, "answer"),
                                    function (d) {
                                      return _c("li", { key: `adoc-${d.id}` }, [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "doc-link",
                                            attrs: {
                                              href: d.url,
                                              download: d.documentname,
                                              target: "_blank",
                                              rel: "noopener",
                                            },
                                          },
                                          [_vm._v(_vm._s(d.documentname))]
                                        ),
                                      ])
                                    }
                                  ),
                                  0
                                ),
                              ])
                            : _vm._e(),
                          _c("div", { staticClass: "mt-1" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center justify-content-end",
                              },
                              [
                                _c("input", {
                                  ref: _vm.fileRefId(data.item.id, "answer"),
                                  staticClass: "d-none",
                                  attrs: { type: "file", multiple: "" },
                                  on: {
                                    change: function ($event) {
                                      return _vm.onNativeFilesPicked(
                                        data.item.id,
                                        "answer",
                                        $event
                                      )
                                    },
                                  },
                                }),
                                _vm.canAnswer
                                  ? _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            modifiers: { hover: true },
                                          },
                                        ],
                                        staticClass: "mr-2",
                                        attrs: {
                                          size: "sm",
                                          variant: "outline-secondary",
                                          title: "Add attachments",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.triggerFilePicker(
                                              data.item.id,
                                              "answer"
                                            )
                                          },
                                        },
                                      },
                                      [_c("b-icon-paperclip")],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.canAnswer
                                  ? _c(
                                      "b-button",
                                      {
                                        staticClass: "mr-2",
                                        attrs: {
                                          size: "sm",
                                          variant: "success",
                                          disabled:
                                            (!_vm.hasDraft(
                                              data.item.id,
                                              "answer"
                                            ) &&
                                              !_vm.hasFiles(
                                                data.item.id,
                                                "answer"
                                              )) ||
                                            _vm.sendingMap[
                                              _vm.getKey(data.item.id, "answer")
                                            ],
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.send(data.item, "answer")
                                          },
                                        },
                                      },
                                      [
                                        _vm.sendingMap[
                                          _vm.getKey(data.item.id, "answer")
                                        ]
                                          ? _c("b-spinner", {
                                              staticClass: "mr-1",
                                              attrs: { small: "" },
                                            })
                                          : _vm._e(),
                                        _vm._v(" Send "),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm.hasFiles(data.item.id, "answer")
                              ? _c(
                                  "ul",
                                  {
                                    staticClass:
                                      "mt-2 mb-0 pl-3 small text-muted",
                                  },
                                  _vm._l(
                                    _vm.filesOf(data.item.id, "answer"),
                                    function (f, i) {
                                      return _c(
                                        "li",
                                        { key: `af-${data.item.id}-${i}` },
                                        [_vm._v(" " + _vm._s(f.name) + " ")]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                },
                _vm.canAsk
                  ? {
                      key: "cell(action)",
                      fn: function (data) {
                        return [
                          _vm.showAction(data.item)
                            ? _c(
                                "b-button",
                                {
                                  attrs: {
                                    size: "sm",
                                    variant: "success",
                                    disabled: _vm.markingMap[data.item.id],
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.markComplete(data.item)
                                    },
                                  },
                                },
                                [
                                  _vm.markingMap[data.item.id]
                                    ? _c("b-spinner", {
                                        staticClass: "mr-1",
                                        attrs: { small: "" },
                                      })
                                    : _vm._e(),
                                  _vm._v(" Mark Complete "),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      },
                    }
                  : null,
                _vm.total > 0
                  ? {
                      key: "custom-foot",
                      fn: function (data) {
                        return [
                          _c(
                            "b-tr",
                            { staticClass: "align-middle" },
                            [
                              _c(
                                "b-td",
                                { attrs: { colspan: +data.columns } },
                                [
                                  _c("TransactionPagination", {
                                    staticClass: "m-0",
                                    attrs: {
                                      "current-page": _vm.currentPage,
                                      "per-page": _vm.perPage,
                                      "total-records": _vm.total,
                                      "table-name": _vm.tableName,
                                    },
                                    on: {
                                      "update-page": (v) => {
                                        _vm.$emit("update-page", v)
                                      },
                                      "update-per-page": (v) => {
                                        _vm.$emit("update-per-page", v)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    }
                  : null,
              ],
              null,
              true
            ),
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }